"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get PATIENT_ALERT_LABELS () {
        return PATIENT_ALERT_LABELS;
    },
    get PatientAlertSchema () {
        return PatientAlertSchema;
    }
});
const _zod = require("zod");
const PatientAlertSchema = _zod.z.enum([
    'diabetic',
    'cardiac',
    'pwd'
]);
const PATIENT_ALERT_LABELS = {
    diabetic: 'Diabetic',
    cardiac: 'Cardiac',
    pwd: 'PWD'
};
